import { call, put, takeLatest, select, all} from 'redux-saga/effects';
import { getApiSettings } from './api';
import { request } from '@vfde-fe/sails_core';

import {
    GET_WEBCHAT,
} from './constants';
import {
    getWebchatSuccess,
    getWebchatFailed,
} from './actions';

import {
    IInitWebchat,
} from './api';
import {TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE} from 'Container/Tracking/constants';
import {
    selectTopic,
    selectWebchatPath,
    selectWebchatUserData,
} from 'Container/Ui/selector';

/**
 * initWebchat
 */
export function* initWebchat () {
    try {

        const [topic, webchatPath, webchatUserData] =
        yield all ([
            select(selectTopic()),
            select(selectWebchatPath()),
            select(selectWebchatUserData()),
        ]);
        const data: IInitWebchat = {
            nickName: 'foo bar',
            lastName: 'bar',
            firstName: 'foo',
            userData: webchatUserData,
        };
        const apiSettings = getApiSettings(data, topic);

        const response = yield call(request, webchatPath, apiSettings);
        // create and yield a dispatch Effect
        yield put(getWebchatSuccess(response.body));
    } catch (error) {
        yield put(getWebchatFailed(true, error?.res?.status || TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE));
    }

  }

/**
 *  initWebchatSaga
 */
export default function* initWebchatSaga () {
    yield takeLatest(GET_WEBCHAT, initWebchat);
}
